import React from 'react';
import {useCurrentRoute} from '~/CreateFabricGreetingCard/navigation';
import {numSteps} from '~/CreateFabricGreetingCard/navigation/createSteps';
import './NavHeader.sass';

export const ProgressBar = (props) => {
  const {id} = useCurrentRoute();

  return (
    <progress
      className="fabric_header__progress-bar"
      min="0"
      max="100"
      value={(id / numSteps) * 100}
    />
  );
};
